import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, LinearProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import AppUtil from "../../../../utilities/AppUtil";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../Table/TablePaginationActions";
import AppTable from "../Table/AppTable";
import { fetchBookingBilling } from "../../../../store/slices/booking";
import AppConfig from "config/AppConfig";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AppDialog from "components/Dialog/AppDialog";
import SegmentTable from "./SegmentTable";
const headCells = [
  {
    id: "date",
    numeric: "left",
    disablePadding: false,
    label: "label.date",
    sort: true,
  },
  {
    id: "titleJob",
    numeric: "left",
    disablePadding: false,
    label: "label.job",
    sort: true,
  },
  {
    id: "workerName",
    numeric: "left",
    disablePadding: false,
    label: "label.staff",
    sort: true,
  },
  {
    id: "shift",
    numeric: "left",
    disablePadding: false,
    label: "label.shift",
    sort: true,
  },
  {
    id: "workingTime",
    numeric: "left",
    disablePadding: false,
    label: "label.working_time",
    sort: true,
  },
  {
    id: "totalHours",
    numeric: "left",
    disablePadding: false,
    label: "title.totalHours",
    sort: true,
  },
  {
    id: "price",
    numeric: "left",
    disablePadding: false,
    label: "label.price",
    sort: true,
  },
  {
    id: "totalPrice",
    numeric: "left",
    disablePadding: false,
    label: "label.total_price",
    sort: true,
  },
  {
    id: "detail",
    numeric: "center",
    disablePadding: false,
    label: "label.detail",
    sort: false,
  },
];

const BillingDetailTable = (props) => {
  const { detail, worker, job } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [initialize, setInitialize] = useState(true);
  const [loading, setLoading] = useState(false);
  const [queries, setQueries] = useState({
    sort: true,
    pageNumber: 1,
    pageSize: 10,
    sortField: "createdDate",
    jobId: "",
    billingId: detail.id,
    workerId: "",
  });
  const [totalElements, setTotalElements] = useState(0);
  const [data, setData] = useState([]);
  const [showSegmentDetail, setShowSegmentDetail] = useState(false);
  const [segmentList, setSegmentList] = useState([]);
  const emptyRows = data.length === 0;

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, pageNumber: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      pageNumber: 1,
      pageSize: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };

  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sortField: property,
      sort: property === queries.sortField ? queries.sort !== true : true,
    });
  };

  const _loadData = async ({
    pageNumber,
    pageSize,
    sort,
    sortField,
    workerId,
    billingId,
    jobId,
  } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (workerId !== undefined) {
      newQueries.workerId = workerId;
    }
    if (billingId !== undefined) {
      newQueries.billingId = billingId;
    }
    if (jobId !== undefined) {
      newQueries.jobId = jobId;
    }
    if (pageNumber) {
      newQueries.pageNumber = pageNumber;
    }
    if (pageSize) {
      newQueries.pageSize = pageSize;
    }
    if (sortField) {
      newQueries.sortField = sortField;
    }
    newQueries.sort = !(!sort || false);
    setLoading(true);
    dispatch(fetchBookingBilling(newQueries)).then(({ payload }) => {
      setLoading(false);
      if (payload) {
        setQueries(newQueries);
        setTotalElements(payload.totalElements);
        setData(payload.content);
      } else {
        // setData([
        //     {
        //         id: 899,
        //         date: "2024-09-26",
        //         titleJob: "JOB QC004",
        //         workerName: "nhu nhu006",
        //         startTime: "2024-09-26T10:37:00Z",
        //         endTime: "2024-09-27T02:35:00Z",
        //         shiftType: "MORNING",
        //         totalHours: 15.97,
        //         totalPrice: 1756.7
        //     },
        //     {
        //         id: 872,
        //         date: "2024-09-26",
        //         titleJob: "JOB QC004",
        //         workerName: "nhu nhu006",
        //         startTime: "2024-09-26T03:49:01Z",
        //         endTime: "2024-09-26T10:37:00Z",
        //         shiftType: "AFTERNOON",
        //         totalHours: 6.8,
        //         totalPrice: 155,
        //         bookingRateResponse: {
        //             shiftType: "AFTERNOON",
        //             totalHours: 5.8,
        //             totalPrice: 145,
        //             bookingSegmentRateResponses: [
        //                 {
        //                     id: 20,
        //                     bookingId: 872,
        //                     rateId: 3549,
        //                     shiftType: "NIGHT",
        //                     startTime: "2024-09-25T04:00:00Z",
        //                     endTime: "2024-09-25T05:00:00Z",
        //                     payToStaff: 100,
        //                     billToClient: 10,
        //                     realTotalSegmentHours: 1,
        //                     totalHours: 1,
        //                     totalPrice: 10
        //                 }
        //             ]
        //         }
        //     }
        // ]);
      }
    });
  };

  const handleViewSegmentDetail = (detail) => {
    const { bookingRateResponse } = detail;
    let arr = [];
    // const bookingRateResponse = {
    //     shiftType: "AFTERNOON",
    //     totalHours: 5.8,
    //     totalPrice: 145,
    //     bookingSegmentRateResponses: [
    //         {
    //             id: 20,
    //             shiftType: "NIGHT",
    //             totalHours: 1,
    //             totalPrice: 10
    //         }
    //     ]
    // };
    arr.push({
      shiftType: bookingRateResponse.shiftType,
      totalHours: bookingRateResponse.totalHours,
      price: bookingRateResponse.price,
      totalPrice: bookingRateResponse.totalPrice,
    });
    arr = [...arr, ...bookingRateResponse.bookingSegmentRateResponses];
    setSegmentList(arr);
    setShowSegmentDetail(true);
  };

  useEffect(() => {
    _loadData().then(() => setInitialize(false));
  }, []);

  useEffect(() => {
    !initialize &&
      _loadData({
        workerId: worker,
      });
  }, [worker]);

  useEffect(() => {
    !initialize &&
      _loadData({
        jobId: job,
      });
  }, [job]);

  return (
    <Box>
      <AppTable
        onRequestSort={onRequestSort}
        order={queries.sort === true ? "asc" : "desc"}
        orderBy={queries.sortField}
        rowCount={data.length}
        headCells={headCells}
        // numSelected={selected.length}
        // onSelectAllClick={_handleSelectAll}
      >
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={headCells.length} padding="none">
                <LinearProgress />
              </TableCell>
            </TableRow>
          )}
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                {AppUtil.formatDate(row.date, AppConfig.DATE_FORMAT.DEFAULT)}
              </TableCell>
              <TableCell>{row.titleJob}</TableCell>
              <TableCell>{row.workerName}</TableCell>
              <TableCell>{t(`shift.${row.shiftType}`)}</TableCell>
              <TableCell>
                {AppUtil.formatDate(row.startTime, "H:mm")} -{" "}
                {AppUtil.formatDate(row.endTime, "H:mm")}
              </TableCell>
              <TableCell>{row.totalHours.toFixed(2)}</TableCell>
              <TableCell>${AppUtil.formatMoney(row.price)}</TableCell>
              <TableCell>${AppUtil.formatMoney(row.totalPrice)}</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                {row.bookingRateResponse ? (
                  <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewSegmentDetail(row)}
                  />
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.pageSize}
              page={queries.pageNumber - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count: count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
      <AppDialog
        title={t("title.configurationDetail")}
        maxWidth={"sm"}
        open={showSegmentDetail}
        onClose={() => {
          setShowSegmentDetail(false);
          setSegmentList([]);
        }}
      >
        <SegmentTable data={segmentList} />
      </AppDialog>
    </Box>
  );
};

BillingDetailTable.propTypes = {
  detail: PropTypes.object,
  worker: PropTypes.any,
  job: PropTypes.any,
};

export default BillingDetailTable;
